export default __webpack_public_path__ + "static/media/leftman.e98043e6.png";